import { ERROR_CODE } from "../../utils/constant/constant";

const validateEmail = async (email) => {
    const responseObj = { isValid: true, message: 'Email is valid' };
  
    try {
      const url = `${process.env.REACT_APP_EMAIL_TLD_VALIDATION_API_ENDPOINT ?? 'https://npr-email-validation.api.pens.com/v1/validate-email'}`
      const response = await fetch(`${url}?email=${encodeURIComponent(email)}&timeout=15000`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key' : process.env.REACT_APP_NP_API_KEY_CLIENT_JS ?? ''
        },
      });

      if (!response.ok) {
        throw { errorCode: ERROR_CODE.GENERIC_ERROR };
      }

      const result = await response.json();
  
      if (result?.Items?.[0]?.ResponseCode === 'Invalid') {
        responseObj.isValid = false;
        responseObj.message = 'Email is invalid';
      }
    } catch (err) {
      throw { errorCode: ERROR_CODE.GENERIC_ERROR }
    }
  
    return responseObj;
  };

export default validateEmail;
